export default __webpack_public_path__ + "static/media/logo_small.9d9fc251.png";